module.exports = __webpack_public_path__ + "static/media/round-check.51117975.svg";